import { ClipboardList } from 'lucide-react';

export function ActionLogPage() {
  return (
    <div className="w-full min-h-full bg-gray-50" dir="rtl">
      {/* Mobile-first header */}
      <div className="w-full bg-white border-b border-gray-200 px-4 py-4 sm:px-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 text-primary-600 shrink-0">
            <ClipboardList className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900 leading-tight">יומן פעולות</h1>
            <p className="text-sm text-gray-500 mt-0.5">היסטוריית פעולות ושינויים בעובדים</p>
          </div>
        </div>
      </div>

      {/* Content area */}
      <div className="w-full px-4 py-6 sm:px-6">
        <div className="w-full max-w-2xl mx-auto">
          {/* Placeholder content */}
          <div className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col items-center justify-center gap-3 min-h-[200px]">
            <ClipboardList className="w-10 h-10 text-gray-300" />
            <p className="text-gray-400 text-sm text-center">
              עמוד יומן פעולות יהיה זמין בקרוב
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
